import React, { useState, useEffect } from "react";
import { Box, Button, TextField, FormControl, InputLabel, Select, MenuItem, InputAdornment } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { Add, Search } from "@mui/icons-material";
import { useTranslation } from "react-i18next";
import { LangConstant } from "const";
import { useUnitList, useDepartmentList } from "hooks";

const HeadingDetail = ({
  form,
  onChangeSearchInput,
  onChangeUnitDropdown,
  onChangeDepartmentDropdown,
  onOpenEditAdminDialog,
  selectedUsers,
  onRemoveAdmin,
}) => {
  const classes = useStyles();
  const { t: getLabel } = useTranslation([LangConstant.NS_COMMON, LangConstant.NS_LOGIN]);

  const { totalUnitList } = useUnitList();
  const { departmentList, handleToggleShowDepartment } = useDepartmentList();

  const [unitList, setUnitList] = useState([]);
  const [selectedUnitId, setSelectedUnitId] = useState(null);
  const [filterDepartmentList, setFilterDepartmentList] = useState([]);

  useEffect(() => {
    if (totalUnitList) {
      setUnitList(
        [
          { unitId: 0, unitName: "Tất cả" },
          { unitId: -1, unitName: "Khác" },
        ].concat(
          totalUnitList.sort((a, b) => {
            return a.unitName.localeCompare(b.unitName, "vi");
          }),
        ),
      );
    }
  }, [totalUnitList]);

  useEffect(() => {
    if (Object.keys(departmentList).includes(selectedUnitId)) {
      setFilterDepartmentList(
        [
          { departmentId: 0, departmentName: "Tất cả" },
          { departmentId: -1, departmentName: "Khác" },
        ].concat(
          departmentList[selectedUnitId].sort((a, b) => {
            return a.departmentName.localeCompare(b.departmentName, "vi");
          }),
        ),
      );
    } else {
      setFilterDepartmentList([
        { departmentId: 0, departmentName: "Tất cả" },
        { departmentId: -1, departmentName: "Khác" },
      ]);
    }
  }, [departmentList, selectedUnitId]);

  const onChangeUnit = e => {
    setSelectedUnitId(e.target.value);
    onChangeUnitDropdown(e);
    handleToggleShowDepartment(e.target.value);
  };
  return (
    <Box className={classes.headerContainer}>
      <Box className={classes.searchBox}>
        <TextField
          fullWidth
          size="small"
          variant="outlined"
          defaultValue={form.search}
          onChange={onChangeSearchInput}
          label={getLabel(LangConstant.P_ADD_NEW_USER)}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <Search className={classes.searchIcon} />
              </InputAdornment>
            ),
          }}
        />

        <FormControl sx={{ ml: 1, width: 320 }}>
          <InputLabel>Đơn vị</InputLabel>
          <Select size="small" value={form.unitId} onChange={e => onChangeUnit(e)} label="Đơn vị">
            {unitList.map(data => (
              <MenuItem key={data.unitId} value={data.unitId}>
                {data.unitName}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <FormControl sx={{ ml: 1, width: 320 }}>
          <InputLabel>Phòng ban</InputLabel>
          <Select size="small" value={form.departmentId} onChange={onChangeDepartmentDropdown} label="Phòng ban">
            {filterDepartmentList.map(data => (
              <MenuItem key={data.departmentId} value={data.departmentId}>
                {data.departmentName}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Box>
      <Box className={classes.topButtonContainer}>
        <Button
          className={classes.deleteButton}
          disabled={selectedUsers.length === 0}
          onClick={() => onRemoveAdmin()}
          variant="contained"
          color="error"
        >
          {getLabel(LangConstant.TXT_DELETE_ADMIN)}
        </Button>
        <Button
          variant="contained"
          className={classes.button}
          startIcon={<Add fontSize="small" />}
          onClick={onOpenEditAdminDialog}
        >
          {getLabel("TXT_ADD_ADMIN")}
        </Button>
      </Box>
    </Box>
  );
};

export default HeadingDetail;

const useStyles = makeStyles(theme => ({
  headerContainer: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: 24,
    flexWrap: "wrap",
    gap: "16px",

    [theme.breakpoints.down("lg")]: {
      flexDirection: "column",
      alignItems: "flex-start",
    },
  },

  topButtonContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    gap: "8px",

    [theme.breakpoints.down("lg")]: {
      width: "100%",
      justifyContent: "flex-start",
    },
  },

  searchBox: {
    display: "flex",
    alignItems: "center",
    width: "1000px",

    [theme.breakpoints.down("lg")]: {
      width: "100%",
      justifyContent: "flex-start",
    },
  },

  mainContainer: {
    marginBottom: 16,
  },

  speedDial: {
    position: "absolute",
    top: "-18px",
    right: 0,
    fontSize: "12px",

    "& > button": {
      width: "120px",
      height: "36px",
      borderRadius: "4px",
    },

    "& .MuiSpeedDialAction-staticTooltipLabel": {
      width: "200px !important",
    },
  },
}));
